module.exports = __webpack_public_path__ + "img/ic_qmarker_dumpster_cluster_issue.17520d9b.png";